module.exports = __webpack_public_path__ + "img/num_22.6d88d93e.png";